import React, { useEffect } from 'react';
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import { toast } from 'react-hot-toast';
import { ParentOrder } from '../../types/index';

// Sound effect for new orders (optional, but helpful)
const notificationSound = new Audio('/notification.mp3'); // Ensure you have a file or use a URL

const AdminOrderListener: React.FC = () => {
  useEffect(() => {
    // Listen for orders created in the last minute to avoid spamming on reload
    const now = new Date();
    const fiveMinutesAgo = new Date(now.getTime() - 5 * 60 * 1000);

    const q = query(
      collection(db, 'parent_orders'),
      where('createdAt', '>=', fiveMinutesAgo),
      orderBy('createdAt', 'desc')
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === 'added') {
          const order = change.doc.data() as ParentOrder;
          
          // Only notify for truly new orders (avoiding cached reads on init)
          // We use a small buffer or metadata check in a real app, 
          // but here we rely on the query timestamp.
          
          // Play sound
          notificationSound.play().catch(e => console.log("Audio play failed:", e));

          // Show Toast
          toast.custom((t) => (
            <div
              className={`${
                t.visible ? 'animate-enter' : 'animate-leave'
              } max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
            >
              <div className="flex-1 w-0 p-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0 pt-0.5">
                    <span className="text-2xl">🔔</span>
                  </div>
                  <div className="ml-3 flex-1">
                    <p className="text-sm font-medium text-gray-900">
                      New Order Received!
                    </p>
                    <p className="mt-1 text-sm text-gray-500">
                      Customer: {order.customerName} <br/>
                      Total: ₹{order.totalAmount}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex border-l border-gray-200">
                <button
                  onClick={() => toast.dismiss(t.id)}
                  className="w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                  Close
                </button>
              </div>
            </div>
          ), { duration: 10000 }); // Show for 10 seconds
        }
      });
    });

    return () => unsubscribe();
  }, []);

  return null; // This component renders nothing visible itself
};

export default AdminOrderListener;